import React from "react";
import { motion } from "framer-motion";

const SkillBar = ({ label, percent, delay = 0.5 }) => (
  <div className="overflow-x-hidden">
    <p className="text-sm uppercase font-medium">{label}</p>
    <span className="w-full h-2 bgOpacity rounded-md inline-flex mt-2">
      <motion.span
        initial={{ x: "-100%", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay }}
        className={`w-[${percent}%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative`}
        style={{ width: `${percent}%` }}
      >
        <span className="absolute -top-7 right-0">{percent}%</span>
      </motion.span>
    </span>
  </div>
);

const Skills = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* Left: Backend & Development Skills */}
      <div className="w-full lgl:w-1/2">
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">
            Proficiency
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">Backend & Development</h2>
        </div>
        <div className="flex flex-col gap-6">
          <SkillBar label="Node.js / TypeScript" percent={90} />
          <SkillBar label="NestJS" percent={88} />
          <SkillBar label="Express.js" percent={92} />
          <SkillBar label="REST APIs & Microservices" percent={95} />
          <SkillBar label="Java / Spring Boot" percent={80} />
          <SkillBar label="MongoDB" percent={85} />
          <SkillBar label="MySQL" percent={80} />
          <SkillBar label="OAuth2 / JWT" percent={88} />
        </div>
      </div>

      {/* Right: Cloud, DevOps & Tools */}
      <div className="w-full lgl:w-1/2">
        <div className="py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px] uppercase">
            Proficiency
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">Cloud, DevOps & Tools</h2>
        </div>
        <div className="flex flex-col gap-6">
          <SkillBar label="Docker & Kubernetes" percent={90} />
          <SkillBar label="AWS (EC2, EKS, S3, Route53)" percent={82} />
          <SkillBar label="CI/CD (GitHub Actions + Jenkins)" percent={90} />
          <SkillBar label="Terraform / Ansible" percent={75} />
          <SkillBar label="Prometheus & Grafana" percent={78} />
          <SkillBar label="NGINX / SSL/TLS" percent={85} />
          <SkillBar label="Marketplace APIs (Amazon, Walmart, TikTok)" percent={88} />
          <SkillBar label="Postman / Swagger / OpenAPI" percent={90} />
        </div>
      </div>
    </motion.div>
  );
};

export default Skills;